const scrollToId = (id: string) => {
  setTimeout(() => {
    const element = document.getElementById(`item-${id}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      console.warn(`Elemento con id "item-${id}" no encontrado.`);
    }
  });
};

export default scrollToId;
